import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3" }, "Información básica", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-name"
}, "Nombre", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-lastname"
}, "Apellido", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-doc-type"
}, "Tipo documento", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-doc-number"
}, "Número documento", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-birthdate"
}, "Fecha de nacimiento", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-gender"
}, "Género", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3 mt-2" }, "Contacto", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-workemail"
}, "Correo institucional", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-personalemail"
}, "Correo personal", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-primaryphone"
}, "Teléfono principal", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-secondaryphone"
}, "Teléfono secundario", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3 mt-2" }, "Dirección", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-address"
}, "Dirección", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-desc-address"
}, " Indicaciones dirección Apto / Casa / Unidad / Otro ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-neighborhood"
}, "Barrio / Vereda", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-country"
}, "País", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-department"
}, "Departamento", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-city"
}, "Ciudad", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-housing"
}, "Tipo de vivienda", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_select = _resolveComponent("b-form-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-name",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.Name }]),
                    modelValue: _ctx.recordProxy.Name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = val => _ctx.updateField('Name', val)),
                    placeholder: "Ingrese nombre",
                    type: "text",
                    required: ""
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_3,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-lastname",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.LastName }]),
                    modelValue: _ctx.recordProxy.LastName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = val => _ctx.updateField('LastName', val)),
                    type: "text",
                    required: "",
                    placeholder: "Ingrese apellido"
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_select, {
                    id: "input-doc-type",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.DocumentType }]),
                    modelValue: _ctx.recordProxy.DocumentType,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = val => _ctx.updateField('DocumentType', val)),
                    options: _ctx.Documents,
                    "value-field": "Id",
                    "text-field": "Description",
                    required: ""
                  }, null, 8, ["modelValue", "options", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_5,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-doc-number",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.IdentificationNumber }]),
                    modelValue: _ctx.recordProxy.IdentificationNumber,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = val => _ctx.updateField('IdentificationNumber', val)),
                    placeholder: "Ingrese número documento",
                    type: "text",
                    required: ""
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_6,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-birthdate",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.BirthDate }]),
                    modelValue: _ctx.recordProxy.BirthDate,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = val => _ctx.updateField('BirthDate', val)),
                    type: "date",
                    required: ""
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_7,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_select, {
                    id: "input-gender",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.Gender }]),
                    modelValue: _ctx.recordProxy.Gender,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = val => _ctx.updateField('Gender', val)),
                    options: _ctx.GenderOptions,
                    required: ""
                  }, null, 8, ["modelValue", "options", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_8,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_9,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-workemail",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && _ctx.invalidEmail(_ctx.recordProxy.WorkEmail) }]),
                    modelValue: _ctx.recordProxy.WorkEmail,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = val => _ctx.updateField('WorkEmail', val)),
                    placeholder: "correo@colegio.edu",
                    type: "email"
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Correo inválido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_10,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-personalemail",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && _ctx.invalidEmail(_ctx.recordProxy.PersonalEmail) }]),
                    modelValue: _ctx.recordProxy.PersonalEmail,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = val => _ctx.updateField('PersonalEmail', val)),
                    placeholder: "correo@dominio.com",
                    type: "email"
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Correo inválido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_11,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-primaryphone",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.PrimaryPhone }]),
                    modelValue: _ctx.recordProxy.PrimaryPhone,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = val => _ctx.updateField('PrimaryPhone', val)),
                    placeholder: "+57 3xx xxx xxxx",
                    type: "tel",
                    required: ""
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_12,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-secondaryphone",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.SecondaryPhone,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = val => _ctx.updateField('SecondaryPhone', val)),
                    placeholder: "+57 3xx xxx xxxx",
                    type: "tel"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_13,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_14,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-address",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.Address }]),
                    modelValue: _ctx.recordProxy.Address,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = val => _ctx.updateField('Address', val)),
                    type: "text",
                    required: ""
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_15,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-desc-address",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.DescriptionAddress,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = val => _ctx.updateField('DescriptionAddress', val)),
                    type: "text"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_16,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-neighborhood",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.Neighborhood }]),
                    modelValue: _ctx.recordProxy.Neighborhood,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = val => _ctx.updateField('Neighborhood', val)),
                    type: "text",
                    required: ""
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_17,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_select, {
                    id: "input-country",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.DocumentType }]),
                    modelValue: _ctx.recordProxy.Country,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = val => _ctx.updateField('Country', val)),
                    options: _ctx.Country,
                    "value-field": "Id",
                    "text-field": "Name",
                    required: ""
                  }, null, 8, ["modelValue", "options", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_18,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_select, {
                    id: "input-department",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.DocumentType }]),
                    modelValue: _ctx.recordProxy.Department,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = val => _ctx.updateField('Department', val)),
                    options: _ctx.Department,
                    "value-field": "Id",
                    "text-field": "Name",
                    required: ""
                  }, null, 8, ["modelValue", "options", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_19,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_select, {
                    id: "input-city",
                    class: _normalizeClass(["form-control fs-14 text-black shadow-none form-control-sm", { 'is-invalid': _ctx.wasValidated && !_ctx.recordProxy.DocumentType }]),
                    modelValue: _ctx.recordProxy.City,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = val => _ctx.updateField('City', val)),
                    options: _ctx.City,
                    "value-field": "Id",
                    "text-field": "Name",
                    required: ""
                  }, null, 8, ["modelValue", "options", "class"]),
                  _createVNode(_component_b_form_invalid_feedback, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Campo requerido")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          cols: "6",
          sm: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_20,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_select, {
                    id: "input-housing",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.TypeOfHousing,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = val => _ctx.updateField('TypeOfHousing', val)),
                    options: _ctx.HousingOptions
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}